import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const tagsMenuSkeletons: TSkeletons = Array(7).fill({
  width: 150,
  height: 20,
})
